import React from 'react';
import PropTypes from 'prop-types';
import {uid} from 'react-uid';
import {Box, Button} from '@tenancy.nz/ui';

function Actions({items, sticky = false, sx = {}}) {
  const styles = {
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    flexDirection: {xs: 'column', sm: 'row'},
    gap: '10px',
    justifyContent: 'flex-start',
    '& > *': {
      width: {xs: '100%', sm: 'auto'},
      whiteSpace: 'nowrap',
    },
    ...(sticky && {
      position: 'sticky',
      left: 0,
      bottom: 0,
      margin: '40px 0 0 0',
    }),
    ...sx,
  };
  if (items.length === 0) {
    return null;
  }
  return (
    <Box sx={styles}>
      {items.map(({text, ...item}, i) => (
        <Button key={uid({...item, text}, i)} color="primary" {...item}>
          {text}
        </Button>
      ))}
    </Box>
  );
}

Actions.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  sticky: PropTypes.bool,
  sx: PropTypes.shape({}),
};

export default Actions;
